import React, { useState, useEffect } from 'react';
import api from '../../../services/api';

const Payslips = () => {
  const [payslips, setPayslips] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPayslips();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchPayslips = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/me/payslips`);
      setPayslips(res.data);
    } catch (error) {
      console.error(error);
      alert('Failed to fetch payslips');
    }
    setLoading(false);
  };

  const downloadPayslip = async (id) => {
    try {
      const res = await api.get(`/me/payslips/${id}/download`);
      window.open(res.data.url, '_blank');
    } catch (error) {
      console.error(error);
      alert('Failed to get download link');
    }
  };

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-800 mb-8 tracking-tight">My Payslips</h1>
      
      {loading ? (
        <div className="text-center py-10 text-gray-500">Loading...</div>
      ) : (
        <div className="bg-white rounded-xl shadow overflow-hidden border border-gray-200">
          <ul className="divide-y divide-gray-200">
            {payslips.length === 0 ? (
              <li className="px-6 py-8 text-center text-gray-500">No payslips available.</li>
            ) : (
              payslips.map(payslip => (
                <li key={payslip._id} className="px-6 py-5 flex flex-col md:flex-row items-start md:items-center justify-between hover:bg-gray-50 transition duration-150 ease-in-out gap-4 md:gap-0">
                  <div className="flex items-center">
                    <div className="bg-blue-100 rounded-lg p-3 mr-4">
                      <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-800">Payslip - {new Date(payslip.generatedAt).toLocaleDateString(undefined, { year: 'numeric', month: 'long' })}</h3>
                      <p className="text-sm text-gray-500 mt-1">Generated on {new Date(payslip.generatedAt).toLocaleDateString()}</p>
                    </div>
                  </div>
                  <button 
                    onClick={() => downloadPayslip(payslip._id)} 
                    className="flex items-center text-blue-600 bg-blue-50 hover:bg-blue-100 px-4 py-2 rounded-lg font-medium transition duration-150 ease-in-out"
                  >
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg>
                    Download PDF
                  </button>
                </li>
              ))
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Payslips;
